module.exports = __webpack_public_path__ + "046d542a670f924a6e25d081b4a45515.jpg";